.timeslot-confimed-text{color:green}.label{margin-bottom:0rem}.mat-mdc-form-field{margin-bottom:0!important}.empty-space{height:3rem}.control-btn{margin-right:2rem;width:8rem}
/*# sourceMappingURL=timeslot-booking.component-H2OU34HO.css.map */
